import { useNavigate } from "react-router-dom";
import { FIELDS } from "../utils/constants"
import { useEffect, useState } from "react";
import RequestModal from "../../containers/shared/RequestModal";
import GetRequestStyle from "../helpers/GetRequestStyle";
import GetServiceByCode from "../helpers/GetServiceByCode";
import ModalContainer from "../../containers/shared/ModalContainer";
import RadioInput from "../shared/RadioInput";
import apiClient from "../utils/apiClient";
import { CancellationReasons } from "../utils/constants";
import DownArrowIcon from "../icons/down-arrow";
import DownloadInvoice from "./DownloadInvoice";
import GetOrderStyle from "../helpers/GetOrderStyle";
import GetUserRole from "../helpers/GetUserRole";
import TextArea from "../shared/TextArea";
import InputField from "../shared/InputField";
import NormalButton from "../shared/NormalButton";
import Toast from "../shared/Toast";
import useUser from "../helpers/useUser";

export default function OrdersTable({ requests, hidePropertyAndUnitNames=false,type="sub", handleChangeRequsetStatus,closeAllModals,currentPage=false,pageSize=0,handleRefreshRequests=null,fields=false,setIsLoading=false }) {

    const navigate = useNavigate();

    const [user, setUser] = useUser();

    const [selectedRequest, setSelectedRequest] = useState();
    const [showRequestDetails, setShowRequestDetails] = useState(false);
    const [showCancelRequestModal, setShowCancelRequestModal] = useState(false);
    const [selectedCancellationReason, setSelectedCancellationReason] = useState('');
    const [selectedCancellationOption, setSelectedCancellationOption] = useState('');
    const [isCancelRequestDisabled, setIsCancelRequestDisabled] = useState(true);
    const [selectedRequestId, setSelectedRequestId] = useState(null);
    const [dropDownOpen, setDropDownOpen] = useState(false);
    const [prevService, setPrevService] = useState(false);
    const [mainFieldChanged, setMainFieldChanged] = useState(false);
    const [showHelpModal, setShowHelpModal] = useState(false);
    const EmptyTicketForm = {
        "complaintType": "MARKETPLACE",
        "complaintSubject": "",
        "complaintText": ""
    }
    const [ticketForm, setTicketForm] = useState(EmptyTicketForm);
    const [errors, setErrors] = useState(null);
    const [isActionButtonDisabled, setIsActionButtonDisabled] = useState(true);
    const [toast, setToast] = useState({show: false,type: null, message:'' });
  
    useEffect(()=>{
        setDropDownOpen(false);
    },[requests])
    

    const sortBySoonest = (list) => {
        const currentDate = new Date()
        return list.sort(function (a, b) {
            let dateA = new Date(a.startWorkingDate)
            let dateB = new Date(b.startWorkingDate)
            if (dateA > currentDate || dateB > currentDate) {
                return -1;
            }
            return dateA - dateB;
        });
    }

    const getStartWorkingDate = (request) => {
        if(request?.createdAt) {
            return new Date(request?.createdAt).toLocaleDateString("ar-eg", {year: 'numeric', month: 'long', day: 'numeric'});
        } else {
            if(request?.units && Array.isArray(request?.units) && request?.units?.length > 0 && request?.units[0]?.startWorkingDate) {
                let sortedRequests;
                if(request?.units?.length > 1) {
                    sortedRequests = sortBySoonest(request?.units);
                } else {
                    sortedRequests = request?.units;
                }
                return new Date(sortedRequests[0].startWorkingDate).toLocaleDateString("ar-eg", {year: 'numeric', month: 'long', day: 'numeric'});
            } else if(request?.subRequests && Array.isArray(request?.subRequests) && request?.subRequests?.length > 0 && request?.subRequests[0]?.startWorkingDate) {
                let sortedRequests;
                if(request?.subRequests?.length > 1) {
                    sortedRequests = sortBySoonest(request?.subRequests);
                } else {
                    sortedRequests = request?.subRequests;
                }
                return new Date(sortedRequests[0].startWorkingDate).toLocaleDateString("ar-eg", {year: 'numeric', month: 'long', day: 'numeric'});
            } else {
                return 'غير محدد';
            }
        }
    }

    const getUnitsNames = (request) => {
        if(request?.unitName) {
            return request?.unitName;
        } else {
            if(request?.units && Array.isArray(request?.units) && request?.units?.length > 0 && request?.units[0]?.unitName) {
                if(request?.units?.length > 1) {
                    let unitsNames = [];
                    let unitsText;
                    request.units?.map((unit, index) => {
                        unitsNames = [...unitsNames, unit?.unitName];
                    });
                    [...new Set(unitsNames)].map((p,i)=> i===0 ? unitsText = ''+p : unitsText += ' + ' + p);
                    return unitsText;
                } else {
                    return request?.units[0]?.unitName;
                }
            } else if(request?.subRequests && Array.isArray(request?.subRequests) && request?.subRequests?.length > 0 && request?.subRequests[0]?.unitName) {
                if(request?.subRequests?.length > 1) {
                    let unitsNames = [];
                    let unitsText;
                    request.subRequests?.map((sub, index) => {
                        unitsNames = [...unitsNames, sub?.unitName];
                    });
                    [...new Set(unitsNames)].map((p,i)=> i===0 ? unitsText = ''+p : unitsText += ' + ' + p);
                    return unitsText;
                } else {
                    return request?.subRequests[0]?.unitName;
                }
            } else {
                return 'غير محدد';
            }
        }
    }

    const getPropertiesNames = (request) => {
        if(request?.propertyName) {
            return request?.propertyName;
        } else {
            if(request?.units && Array.isArray(request?.units) && request?.units?.length > 0 && request?.units[0]?.propertyName) {
                if(request?.units?.length > 1) {
                    let propertiesNames = [];
                    let propertiesText;
                    request.units?.map((unit, index) => {
                        propertiesNames = [...propertiesNames, unit?.propertyName];
                    });
                    [...new Set(propertiesNames)].map((p,i)=> i===0 ? propertiesText = ''+p : propertiesText += ' + ' + p);
                    return propertiesText;
                } else {
                    return request?.units[0]?.propertyName;
                }
            } else if(request?.subRequests && Array.isArray(request?.subRequests) && request?.subRequests?.length > 0 && request?.subRequests[0]?.propertyName) {
                if(request?.subRequests?.length > 1) {
                    let propertiesNames = [];
                    let propertiesText;
                    request.subRequests?.map((sub, index) => {
                        propertiesNames = [...propertiesNames, sub?.propertyName];
                    });
                    [...new Set(propertiesNames)].map((p,i)=> i===0 ? propertiesText = ''+p : propertiesText += ' + ' + p);
                    return propertiesText;
                } else {
                    return request?.subRequests[0]?.propertyName;
                } 
            } else {
                return 'غير محدد';
            }
        }
    }

    const getFieldName = (request) => {
        if(request?.field?.name?.indexOf("'") > -1) {
            return request?.field?.name?.split("'")[1];
        } else {
            if(request?.field?.name) {
                return request?.field?.name;
            } else {
                return request?.field;
            }
        }
    }


    requests.sort((a, b) => {
        if (a.prettyId < b.prettyId) return 1;
        if (a.prettyId > b.prettyId) return -1;
        return 0;
    });
      

    const handleClickRequestRow = (request) => {
        setDropDownOpen(false);
        setPrevService(false);
        setSelectedRequest(request);
        setSelectedRequestId(request?._id);
        setShowRequestDetails(true);
    }

    const handleCloseModal = () => {
        setShowRequestDetails(false);
    }

    const handleClickCancelRequest = () => {
        setShowRequestDetails(false);
        setSelectedCancellationReason('');
        setSelectedCancellationOption('');
        setShowCancelRequestModal(true);
    }

    const handleCloseCancelRequestModal = () => {
        setShowCancelRequestModal(false);
    }

    const handleClickCancelRequestAction = async() => {
        setIsCancelRequestDisabled(true);
         try {
            const response = await apiClient.patch(`/b-business-requests/${selectedRequestId}/cancel`,{"cancellationReason": selectedCancellationReason});
            if(response?.status === 201 || response?.status === 204 || response?.status === 200) {
                setShowCancelRequestModal(false);
                handleRefreshRequests();
            }
        } catch(err) {}
    }

    useEffect(()=>{
        if (typeof selectedCancellationReason === 'string' && selectedCancellationReason?.length > 3) {
            setIsCancelRequestDisabled(false);
        } else {
            setIsCancelRequestDisabled(true);
        }
    },[selectedCancellationReason])

    useEffect(()=>{
        if(closeAllModals) {
            setShowRequestDetails(false);
        }
    },[closeAllModals])

    const handleClickCancelConfirmPriceChange = () => {
        if(selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.needConfirmation) {
            AcceptSubRequestPriceEditing();
        } else {
            AcceptRequestPriceEditing();
        }
    }


    const AcceptRequestPriceEditing = async () => {
        setIsLoading(true);
        try {
            const response = await apiClient.patch(`/b-business-requests/${selectedRequestId}/confirm-price-editing`);
            if(response?.status === 201 || response?.status === 204 || response?.status === 200) {
                setShowRequestDetails(false);
                handleRefreshRequests();
            }
        } catch(err) {}


    }

    const AcceptSubRequestPriceEditing = async () => {
        setIsLoading(true);
        try {
            const response = await apiClient.patch(`/b-business-requests/sub-request/${selectedRequest?._id}/confirm-price-editing`);
            if(response?.status === 201 || response?.status === 204 || response?.status === 200) {
                setShowRequestDetails(false);
                handleRefreshRequests();
            }
        } catch(err) {}

    }

    const getFieldNameAr = (field) => {
        if(fields) {
            return fields?.find(f=>f?.field?.code === field)?.field?.name?.ar;
        } else {
            return FIELDS[field]?.ar;
        }
    }

    const getFieldIcon = (field) => {
        if(FIELDS[field]?.icon) {
            return "url('/assets/images/"+FIELDS[field]?.icon+"')";
        } else {
            return "url('"+fields?.find(f=>f?.field?.code === field)?.field?.url+"')";
        }
    }

    const getFieldCategoryAr = (field,subFieldCode) => {
        if(fields) {
            let fieldCategory;
            fields?.find(f=>f?.field?.code === field) && fields?.find(f=>f?.field?.code === field)?.maintenanceListPerDevice?.map((d) =>{
                d?.maintenanceList?.map(m=>{
                    if(m?.code === subFieldCode) {
                        fieldCategory = d?.device?.name?.ar;
                    }
                })
            })
            return fieldCategory;
        } else {
            return GetServiceByCode(field, subFieldCode)[0];
        }
    }

    const getSubFieldAr = (field,subFieldCode) => {
        if(fields) {
            let subField;
            fields?.find(f=>f?.field?.code === field) && fields?.find(f=>f?.field?.code === field)?.maintenanceListPerDevice?.map((d) =>{
                d?.maintenanceList?.map(m=>{
                    if(m?.code === subFieldCode) {
                        subField = m?.name?.ar;
                    }
                })
            })
            return subField;
        } else {
            return GetServiceByCode(field, subFieldCode)[1];
        }
    }

    const hideError = (err) => {
      if(errors) {
        let errorsList = errors;
        delete errorsList[err];
        setErrors(errorsList);
      }
    }

    const handleClickShowHelpModal = () => {
        setTicketForm(EmptyTicketForm);
        setShowRequestDetails(false);
        setShowHelpModal(true);
    }

    const handleClickCloseHelpModal = () => {
        setShowHelpModal(false);
    }

    const handleClickSendTicket = async () => {
        setIsLoading(true);
        try {
            const response = await apiClient.post(`/b-users/${selectedRequest?._id}/send-complaint-from-business`,ticketForm);
            if([200,201,204].includes(response?.status)) {
                setShowHelpModal(false);
                setIsLoading(false);
                setToast({show:true,type:'success',message:'تم إرسال الشكوي بنجاح'});
            } else {
                setIsLoading(false);
                setToast({show:true,type:'error',message:'حدث خطأ في إرسال الشكوي'});
            }
        } catch(err) {
            setIsLoading(false);
            setToast({show:true,type:'error',message:err?.response?.data?.message});
        }
    }

    useEffect(()=>{
        if(ticketForm && ticketForm?.complaintSubject && ticketForm?.complaintText && ticketForm?.complaintSubject.toString().length > 3 && ticketForm?.complaintText.toString().length > 3) {
            setIsActionButtonDisabled(false);
        } else {
            setIsActionButtonDisabled(true);
        }
    },[ticketForm])

    const handleClickChangeRequestStatus = async(status) => {
        setIsLoading(true);
        try {
            const response = await apiClient.post(`/orders/${selectedRequestId}/accept-order-exceeded-unit-limit`,{orderStatus: status});
            if(response?.status === 201 || response?.status === 204 || response?.status === 200) {
                setIsLoading(false);
                setShowRequestDetails(false);
                handleRefreshRequests();
            }
            setIsLoading(false);
        } catch(err) {setIsLoading(false);}
    }

    return (
        <>
        <div className="">
            <table className="w-full mt-[30px]" dir="rtl">
                <thead>
                <tr className="border-b-[2px] border-b-grey-50">
                    <th className="bg-darkBlue text-white leading-[56px] rounded-tr-[8px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">#</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">رقم الطلب</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">تاريخ الطلب</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">أنشئ بواسطة</th>
                    {!hidePropertyAndUnitNames && <><th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">المنشأة</th></>}
                    {!hidePropertyAndUnitNames && <><th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">الوحدة</th></>}
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">المتجر</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">التكلفة</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">حالة الطلب</th>
                    <th className="bg-darkBlue text-white leading-[56px] rounded-tl-[8px] text-start px-[15px] text-[16px] font-[500px]"></th>
                </tr>
                </thead>
                <tbody>
                {requests.map((request, index) => {;
                    return (
                    <tr key={`requests-${index}`} className={`${index !== requests?.length-1 && 'border-b-[1px] border-b-grey-200'}`}>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] whitespace-nowrap w-[52px] cursor-pointer ${index === requests?.length-1 && 'rounded-br-[8px]'}`} onClick={()=>handleClickRequestRow(request)}>{currentPage ? ((currentPage-1)*pageSize) + (index+1) : index+1}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] whitespace-nowrap cursor-pointer`} onClick={()=>handleClickRequestRow(request)}>{request?.prettyId}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] whitespace-nowrap cursor-pointer`} onClick={()=>handleClickRequestRow(request)}>{getStartWorkingDate(request)}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] cursor-pointer`} onClick={()=>handleClickRequestRow(request)}>{request?.customer?.name || 'غير معرف'}</td>
                        {!hidePropertyAndUnitNames && <><td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] cursor-pointer`} onClick={()=>handleClickRequestRow(request)}>{request?.businessPropertyPopulated?.name || 'غير معرف'}</td></>}
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] !text-right whitespace-nowrap cursor-pointer`} onClick={()=>handleClickRequestRow(request)}>{request?.businessUnitPopulated?.name || 'غير معرف'}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] !text-right whitespace-nowrap cursor-pointer`} onClick={()=>handleClickRequestRow(request)}>{request?.store?.name || 'غير معرف'}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] !text-right whitespace-nowrap cursor-pointer`} onClick={()=>handleClickRequestRow(request)}>{request?.invoice?.total ? <span>{request?.invoice?.total?.toFixed(2)} <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-middle inline-block select-none" /></span> : 'غير معرف'}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] !text-right whitespace-nowrap`} onClick={()=>handleClickRequestRow(request)}><span className={`font-[600] ${GetOrderStyle(request?.status,'color')}`}>{GetOrderStyle(request?.status)}</span></td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] !text-right whitespace-nowrap w-[48px] ${index === requests?.length-1 && 'rounded-bl-[8px]'}`}>
                        </td>
                    </tr>
                    )
                })}
                </tbody>
            </table> 
        </div>

          { showRequestDetails && <RequestModal textColor={'text-white'} bgColor={GetOrderStyle(selectedRequest?.status,'bg')} heading={GetOrderStyle(selectedRequest?.status,'heading')} handleCloseModal={handleCloseModal}>
            {selectedRequest?.status === 'pending-approval-exceeded-limit' ? <div className="bg-[#FFF0F0] h-[42px] leading-[42px] text-[#D80000] font-[500] cairo-font px-[12px]">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="inline-block align-middle me-[8px]">
                    <path d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z" fill="#D80000"/>
                    <path d="M12 13.75C11.59 13.75 11.25 13.41 11.25 13V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75Z" fill="#D80000"/>
                    <path d="M12 16.9999C11.87 16.9999 11.74 16.9699 11.62 16.9199C11.5 16.8699 11.39 16.7999 11.29 16.7099C11.2 16.6099 11.13 16.5099 11.08 16.3799C11.03 16.2599 11 16.1299 11 15.9999C11 15.8699 11.03 15.7399 11.08 15.6199C11.13 15.4999 11.2 15.3899 11.29 15.2899C11.39 15.1999 11.5 15.1299 11.62 15.0799C11.86 14.9799 12.14 14.9799 12.38 15.0799C12.5 15.1299 12.61 15.1999 12.71 15.2899C12.8 15.3899 12.87 15.4999 12.92 15.6199C12.97 15.7399 13 15.8699 13 15.9999C13 16.1299 12.97 16.2599 12.92 16.3799C12.87 16.5099 12.8 16.6099 12.71 16.7099C12.61 16.7999 12.5 16.8699 12.38 16.9199C12.26 16.9699 12.13 16.9999 12 16.9999Z" fill="#D80000"/>
                </svg>
                لقد تخطيت حد التنبيه لمصاريف الصيانة عن هذة الوحدة
            </div> : ''}
            <div className={`${selectedRequest?.status === 'delivered' || selectedRequest?.status === 'reviewed' || selectedRequest?.status === 'pending-approval-exceeded-limit' ? 'pb-[87px]' : ''}`}>
                
                <div className="">
                    <div className="text-[14px] text-grey-600 font-[500] h-[30px] leading-[30px] my-[10px] px-[16px]">
                        <span className="text-[12px] text-grey-900 font-[600]">رقم الطلب:</span> {selectedRequest?.prettyId}
                    </div>
                    <div className="text-[14px] text-grey-600 font-[500] h-[30px] leading-[30px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                        <span className="text-[12px] text-grey-900 font-[600]">تاريخ الطلب:</span> {new Date(selectedRequest?.createdAt).toLocaleDateString("ar-eg", {year: 'numeric', month: 'long', day: 'numeric'})}
                    </div>
                    <div className="text-[14px] text-grey-600 font-[500] h-[30px] leading-[30px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                        <span className="text-[12px] text-grey-900 font-[600]">أنشئ بواسطة:</span> {selectedRequest?.customer?.name || 'غير معرف'} {selectedRequest?.businessUserPopulated?.role ? <span className="text-[12px] text-grey-400">{GetUserRole(selectedRequest?.businessUserPopulated?.role)}</span> : ''}
                    </div>
                    <div className="text-[14px] text-grey-600 font-[500] h-[30px] leading-[30px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                        <span className="text-[12px] text-grey-900 font-[600]">المنشأة:</span> {selectedRequest?.businessPropertyPopulated?.name || 'غير معرف'}
                    </div>
                    <div className="text-[14px] text-grey-600 font-[500] h-[30px] leading-[30px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                        <span className="text-[12px] text-grey-900 font-[600]">الوحدة:</span> {selectedRequest?.businessUnitPopulated?.name || 'غير معرف'}
                    </div>
                    {selectedRequest?.deliveryUser?.name ? <div className="text-[14px] text-grey-600 font-[500] h-[30px] leading-[30px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                        <span className="text-[12px] text-grey-900 font-[600]">مندوب التوصيل:</span> {selectedRequest?.deliveryUser?.name || 'غير معرف'}
                    </div> : ''}
                </div>
                <div  className="p-[16px] bg-grey-50 border-y-[1px] border-grey-200 my-[10px] relative">
                    <div className="flex flex-nowrap mb-[10px]">
                        <div className="w-[50%] text-[17px] text-grey-900 font-[600]">تفاصيل الطلب</div>
                        <div className="w-[50%] text-end"><span className="bg-grey-300 inline-block rounded-[5px] py-[4px] px-[8px] text-grey-900 text-[14px] font-[700]">{selectedRequest?.store?.name || 'غير معرف'}</span></div>
                    </div>
                    {selectedRequest?.items && Array.isArray(selectedRequest?.items) && selectedRequest?.items?.length > 0 && selectedRequest?.items?.map((item,index)=>{
                        return (
                            <div key={`item-${index}`} className="flex flex-nowrap my-[10px]">
                                <div className="w-[75%] text-[16px] text-grey-600 font-[500]">
                                    <img src={item?.productMeta?.product?.thumbnail} alt="" className="inline-block align-top max-w-[40px]" />
                                    <div className=" inline-block align-top text-[14px] text-grey-600 font-[600] ps-[8px]">
                                        {item?.productMeta?.product?.name} <span className="inline-block text-grey-900 font-[700]">x <span className="inline-block">{item?.quantity}</span></span>
                                        <div className="bg-grey-100 font-[600] text-[12px] text-grey-900 rounded-[16px] px-[8px] leading-[24px] w-fit mt-[2px]">
                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className="inline-block me-[4px]">
                                                <path d="M7.875 4.62591L7.875 8.83284C7.875 9.34922 8.34188 9.76941 8.91563 9.76941H14.0625C14.3719 9.76941 14.625 9.54159 14.625 9.26316L14.625 6.02822C14.625 4.99547 13.6969 4.16016 12.5494 4.16016L8.39813 4.16016C8.10563 4.16016 7.875 4.36772 7.875 4.62591Z" fill="#475569"/>
                                                <path d="M3.65625 10.9953C3.49875 10.9953 3.375 11.1067 3.375 11.2484L3.375 11.7547C3.375 12.5951 4.12875 13.2734 5.0625 13.2734C5.0625 12.4381 5.82187 11.7547 6.75 11.7547C7.67812 11.7547 8.4375 12.4381 8.4375 13.2734H9.5625C9.5625 12.4381 10.3219 11.7547 11.25 11.7547C12.1781 11.7547 12.9375 12.4381 12.9375 13.2734C13.8712 13.2734 14.625 12.5951 14.625 11.7547L14.625 10.7422C14.625 10.4638 14.3719 10.2359 14.0625 10.2359H8.71875C7.9425 10.2359 7.3125 9.66894 7.3125 8.97031L7.3125 6.18594C7.3125 5.9075 7.05937 5.67969 6.75 5.67969H6.2775C5.8725 5.67969 5.50125 5.87713 5.29875 6.191L4.93875 6.758C4.88812 6.839 4.95562 6.94531 5.0625 6.94531C5.83875 6.94531 6.46875 7.51231 6.46875 8.21094L6.46875 9.72969C6.46875 10.4283 5.83875 10.9953 5.0625 10.9953L3.65625 10.9953Z" fill="#475569"/>
                                                <path d="M11.25 14.2867C10.6287 14.2867 10.125 13.8334 10.125 13.2742C10.125 12.715 10.6287 12.2617 11.25 12.2617C11.8713 12.2617 12.375 12.715 12.375 13.2742C12.375 13.8334 11.8713 14.2867 11.25 14.2867Z" fill="#475569"/>
                                                <path d="M6.75 14.2867C6.12868 14.2867 5.625 13.8334 5.625 13.2742C5.625 12.715 6.12868 12.2617 6.75 12.2617C7.37132 12.2617 7.875 12.715 7.875 13.2742C7.875 13.8334 7.37132 14.2867 6.75 14.2867Z" fill="#475569"/>
                                                <path d="M3.375 9.49019L3.375 10.2344H5.0625C5.37188 10.2344 5.625 10.0066 5.625 9.72813L5.625 8.20938C5.625 7.93094 5.37188 7.70312 5.0625 7.70312H4.33687L3.52125 8.989C3.42563 9.14088 3.375 9.313 3.375 9.49019Z" fill="#475569"/>
                                            </svg>
                                            {item?.workerRequired ? 'تركيب وتوصيل' : 'توصيل فقط'}
                                        </div>
                                    </div>
                                </div>
                                <div className="w-[25%] text-[18px] text-grey-900 font-[700] text-end leading-[47px]">{item?.finalPrice?.toFixed(2)} <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-middle inline-block select-none" /></div>
                            </div>
                        )
                    })

                    }
                    
                </div>
                
                <div className="p-[16px]">
                    <p className="mb-[16px] font-[600] text-[16px] text-grey-900">تفاصيل الفاتورة</p>
                    <div className="border-t-[1px] border-dotted border-grey-300">
                        <div className="flex flex-nowrap my-[10px] leading-[30px] h-[30px]">
                            <div className="w-[50%] text-[16px] text-grey-600 font-[500]">المجموع</div>
                            <div className="w-[50%] text-[16px] text-grey-900 font-[500] text-end">{((selectedRequest?.invoice?.subtotal*1000 / 1.15)/1000).toFixed(2)} <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-middle inline-block select-none" /></div>
                        </div>
                        <div className="flex flex-nowrap my-[10px] leading-[30px] h-[30px]">
                            <div className="w-[50%] text-[16px] text-grey-600 font-[500]">مصاريف الشحن</div>
                            <div className="w-[50%] text-[16px] text-grey-900 font-[500] text-end">{ (selectedRequest?.invoice?.deliveryFees - selectedRequest?.invoice?.deliveryFeesVat)?.toFixed(2)} <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-middle inline-block select-none" /></div>
                        </div>
                    </div>
                    <div className="border-t-[1px] border-dotted border-grey-300">
                        <div className="flex flex-nowrap my-[10px] leading-[30px] h-[30px]">
                            <div className="w-[50%] text-[16px] text-grey-600 font-[500]">الضريبة</div>
                            <div className="w-[50%] text-[16px] text-grey-900 font-[500] text-end">{selectedRequest?.invoice?.vat?.toFixed(2)} <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-middle inline-block select-none" /></div>
                        </div>
                    </div>
                    <div className="border-t-[1px] border-dotted border-grey-300">
                        <div className="flex flex-nowrap mt-[10px] leading-[30px] h-[30px]">
                            <div className="w-[50%] text-[16px] text-grey-600 font-[500]">إجمالي ما سيتم دفعه</div>
                            <div className="w-[50%] text-[16px] text-grey-900 font-[500] text-end">{selectedRequest?.invoice?.total?.toFixed(2)} <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-middle inline-block select-none" /></div>
                        </div>
                    </div>
                    
                </div>
            </div>
            
            {selectedRequest?.status === 'delivered' || selectedRequest?.status === 'reviewed' ? <div className="absolute bottom-0 left-0 w-full h-[87px] bg-white shadow-[0_-4px_24px_0_rgba(0,0,0,0.08)] pt-[20px] px-[15px]">
                <div className="flex flex-nowrap">
                    <div className="w-[40%]">
                        <DownloadInvoice requestId={selectedRequest?._id} prettyId={selectedRequest?.prettyId} />
                    </div>
                    <div className="w-[60%] text-end">
                        <div className="w-[201px] h-[48px] leading-[48px] bg-white text-darkBlue border-[1px] border-dartext-darkBlue rounded-[8px] cursor-pointer inline-block text-center select-none text-[18px] font-[600]" onClick={handleClickShowHelpModal}>احتاج إلى مساعدة</div>
                        {/* {selectedRequest?.status === 'delivered' ? <div className="w-[166px] h-[48px] leading-[48px] bg-blue text-white border-[1px] border-blue rounded-[8px] cursor-pointer inline-block text-center select-none text-[18px] font-[600] ms-[16px]" onClick={()=>''}>تقييم الخدمة</div> : ''} */}
                    </div>
                </div>
                
            </div> : ''}

            {(selectedRequest?.status === 'pending-approval-exceeded-limit' && ['OWNER','ADMINISTRATOR'].includes(user?.role)) ? <>
                <div className="absolute bottom-0 left-0 w-full h-[87px] bg-white text-end shadow-[0_-4px_24px_0_rgba(0,0,0,0.08)] pt-[20px] px-[15px]">
                    <div className="w-[201px] h-[48px] leading-[48px] bg-white text-danger border-[1px] border-danger rounded-[8px] cursor-pointer inline-block text-center select-none text-[18px] font-[600] me-[16px]" onClick={()=>handleClickChangeRequestStatus('rejected')}>رفض الطلب</div>
                    <div className="w-[166px] h-[48px] leading-[48px] bg-darkBlue text-white border-[1px] border-darkBlue rounded-[8px] cursor-pointer inline-block text-center select-none text-[18px] font-[600]" onClick={()=>handleClickChangeRequestStatus('pendingMerchant')}>قبول الطلب و الدفع</div>
                </div>
            </> : ''}

        </RequestModal> }

        {showHelpModal && <ModalContainer maxWidth={'775px'} heading="من فضلك قم بتعبئة البيانات التالية لرفع شكوى" handleCloseModal={handleClickCloseHelpModal}>
            
            <div className=" border-b-[1px] border-grey-100 leading-[70px]">
                <p className="font-[400] text-[16px] text-grey-600">سيتم ارسال الشكوي الي الدعم وسيقوم احد عملائنا بالتواصل معك في اقرب وقت ممكن</p>
            </div>

            <div className="pt-[24px]">
                <InputField isRequird label={`موضوع الشكوى`} placeholder={'من فضلك اكتب موضوع الشكوي'} value={ticketForm?.complaintSubject} error={errors?.complaintSubject} errorMessage={errors?.name} translateError={true} onChange={(e)=>{setTicketForm({ ...ticketForm, complaintSubject: e.target.value }); hideError('complaintSubject')}} />
            </div>

            <div className="pb-[14px] pt-[14px]">
               <TextArea isRequird label={`تفاصيل الشكوى`} placeholder={'اكتب موضوع الشكوي لنتمكن من مساعدتك'} value={ticketForm?.complaintText} error={errors?.complaintText} errorMessage={errors?.complaintText} translateError={true} onChange={(e)=>{ setTicketForm({ ...ticketForm, complaintText: e.target.value }); hideError('complaintText')}} />
            </div>

            <div className="w-full h-[70px] bg-white text-end pt-[20px] border-t-[1px] border-grey-100">
                <div className="text-grey-400 text-[18px] font-[600] inline-block cursor-pointer select-none me-[50px]" onClick={handleClickCloseHelpModal}>إلغاء</div>
                <NormalButton isDisabled={isActionButtonDisabled} label={'ارسال الشكوي'} onClick={handleClickSendTicket} />
            </div>

        </ModalContainer>}

        {showCancelRequestModal && <ModalContainer maxWidth={'775px'} heading="إلغاء طلب مستفيد" handleCloseModal={handleCloseCancelRequestModal}>
            
            <div className=" border-b-[1px] border-grey-100 leading-[70px]">
                <p className="font-[400] text-[16px] text-grey-600">من فضلك قم باختيار سبب الإلغاء حتى يتم إبلاغ مسؤول الوحدة</p>
            </div>

            <div className="">
                <RadioInput name={'cancellationReasons-'+selectedRequest?._id} options={CancellationReasons} onChange={(value)=>setSelectedCancellationReason(value)} value={selectedCancellationReason} onSelect={setSelectedCancellationOption} selected={selectedCancellationOption} />
            </div>

            <div className="w-full h-[70px] bg-white text-end pt-[20px] border-t-[1px] border-grey-100">
                    <div className={`w-[201px] h-[48px] leading-[48px] bg-white text-danger border-[1px] border-danger rounded-[8px] cursor-pointer inline-block text-center select-none text-[18px] font-[600] ${isCancelRequestDisabled ? 'opacity-50 pointer-events-none' : ''}`} onClick={isCancelRequestDisabled ? null : handleClickCancelRequestAction}>الغاء الطلب</div>
                </div>

        </ModalContainer>}

        <Toast toast={toast} setToast={setToast} />

        </>
    )
}
